import { Link } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { categories, videos, getHotVideos, getNewVideos } from '@/mocks/videos';

const siteUrl = 'https://xiuxiushipin.com';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '羞羞视频精选合集',
    url: siteUrl,
    description: '羞羞视频栏目汇聚全网最热门、最受欢迎的趣味搞笑与情感类短视频内容，涵盖恋爱日常、甜蜜互动、搞怪萌宠等多元题材。',
    logo: `${siteUrl}/logo.png`,
    sameAs: ['https://weibo.com/xiuxiushipin', 'https://space.bilibili.com/xiuxiushipin'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '羞羞视频精选合集',
    url: siteUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
];

export default function Home() {
  const hotVideos = getHotVideos(6);
  const newVideos = getNewVideos(6);

  return (
    <>
      <SEO
        title="羞羞视频精选合集｜热门内容一站汇聚"
        description="羞羞视频栏目汇聚全网最热门、最受欢迎的趣味搞笑与情感类短视频内容，涵盖恋爱日常、甜蜜互动、搞怪萌宠等多元题材，让你每天都能找到让人脸红心跳的有趣视频，轻松解压、畅享欢乐时光。"
        keywords="羞羞视频,羞羞视频合集,好玩羞羞视频推荐,搞笑羞羞短视频,恋爱羞羞视频,甜蜜互动视频,趣味情感短视频"
        canonicalUrl={siteUrl}
        ogImage={`${siteUrl}/og-home.jpg`}
        schemaData={homeSchema}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[550px] md:h-[680px] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20background%20with%20soft%20pink%20and%20coral%20gradient%20tones%2C%20gentle%20flowing%20curves%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20composition%2C%20modern%20design%2C%20no%20text%2C%20no%20people%2C%20subtle%20texture%2C%20light%20airy%20feel%2C%20warm%20color%20palette&width=1800&height=1000&seq=hero-bg-home&orientation=landscape`,
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-background-50 text-xs font-medium">每日更新 · 精选好视频</span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-6 leading-tight">
                羞羞视频精选合集
              </h1>
              <p className="text-background-100/90 text-base md:text-lg max-w-xl mx-auto mb-8 leading-relaxed">
                汇聚全网最热门的趣味搞笑与情感类短视频，涵盖恋爱日常、甜蜜互动、搞怪萌宠等多元题材，让你每天都能找到让人脸红心跳的有趣视频。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <Link
                  to="/category/quwei-gaoxiao"
                  className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  开始观看
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 rounded-full text-base font-medium transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/30"
                >
                  了解更多
                </Link>
              </div>

              <div className="flex items-center justify-center gap-8 mt-10">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">1000+</div>
                  <div className="text-background-100/70 text-xs mt-1">精选视频</div>
                </div>
                <div className="w-px h-10 bg-background-50/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">50万+</div>
                  <div className="text-background-100/70 text-xs mt-1">每日观众</div>
                </div>
                <div className="w-px h-10 bg-background-50/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">6</div>
                  <div className="text-background-100/70 text-xs mt-1">精选分类</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                视频分类
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">
                探索你感兴趣的内容
              </h2>
              <p className="text-foreground-500 text-sm max-w-lg mx-auto">
                六大精选分类，总有一款适合你。点击分类发现更多精彩视频。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
              {categories.map((cat) => {
                const colorMap: Record<string, { bg: string; text: string; hover: string }> = {
                  primary: { bg: 'bg-primary-100', text: 'text-primary-700', hover: 'hover:bg-primary-500 hover:text-background-50' },
                  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', hover: 'hover:bg-secondary-500 hover:text-background-50' },
                  accent: { bg: 'bg-accent-100', text: 'text-accent-700', hover: 'hover:bg-accent-500 hover:text-background-50' },
                };
                const colors = colorMap[cat.color];
                return (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className={`group flex flex-col items-center gap-3 p-6 rounded-2xl ${colors.bg} transition-all duration-300 ${colors.hover} cursor-pointer`}
                  >
                    <div className={`w-12 h-12 flex items-center justify-center rounded-full ${cat.color === 'primary' ? 'bg-primary-500/20' : cat.color === 'secondary' ? 'bg-secondary-500/20' : 'bg-accent-500/20'} group-hover:bg-background-50/20 transition-colors`}>
                      <i className={`${cat.icon} text-xl ${colors.text} group-hover:text-background-50 transition-colors`}></i>
                    </div>
                    <span className={`text-sm font-medium ${colors.text} group-hover:text-background-50 transition-colors whitespace-nowrap`}>
                      {cat.name}
                    </span>
                    <span className={`text-xs ${cat.color === 'primary' ? 'text-primary-500/70' : cat.color === 'secondary' ? 'text-secondary-500/70' : 'text-accent-500/70'} group-hover:text-background-50/70 transition-colors text-center leading-relaxed`}>
                      {cat.description}
                    </span>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* Hot Videos Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-10">
              <div>
                <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                  <i className="ri-fire-line mr-1"></i>热门推荐
                </span>
                <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">
                  大家都在看
                </h2>
              </div>
              <Link
                to="/category/lianai-richang"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {hotVideos.map((video) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
                >
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={video.coverImage}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`羞羞视频 - ${video.title}`}
                    />
                    <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-foreground-900/75 backdrop-blur-sm rounded-md text-background-50 text-xs font-mono">
                      {video.duration}
                    </div>
                    <div className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 rounded-full text-background-50 text-xs font-medium">
                      热门
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                      {video.title}
                    </h3>
                    <p className="text-foreground-500 text-xs line-clamp-2 mb-3 leading-relaxed">
                      {video.description}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {video.viewCount >= 10000 ? `${(video.viewCount / 10000).toFixed(1)}万` : video.viewCount}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-heart-line"></i>
                        {video.likeCount >= 10000 ? `${(video.likeCount / 10000).toFixed(1)}万` : video.likeCount}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {video.publishDate}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* New Videos Section */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-end justify-between mb-10">
              <div>
                <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                  <i className="ri-sparkling-line mr-1"></i>最新上线
                </span>
                <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">
                  新鲜出炉
                </h2>
              </div>
              <Link
                to="/category/gaoguai-mengchong"
                className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {newVideos.map((video) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer border border-background-200/70"
                >
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={video.coverImage}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`羞羞视频 - ${video.title}`}
                    />
                    <div className="absolute bottom-3 right-3 px-2.5 py-1 bg-foreground-900/75 backdrop-blur-sm rounded-md text-background-50 text-xs font-mono">
                      {video.duration}
                    </div>
                    <div className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 rounded-full text-background-50 text-xs font-medium">
                      新上线
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                        {video.category}
                      </span>
                    </div>
                    <h3 className="font-medium text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                      {video.title}
                    </h3>
                    <p className="text-foreground-500 text-xs line-clamp-2 mb-3 leading-relaxed">
                      {video.description}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{video.author}</span>
                      <span>{video.publishDate}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full px-4 md:px-6 py-20 md:py-28 overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20warm%20abstract%20gradient%20background%20with%20soft%20coral%20and%20peach%20tones%2C%20dreamy%20flowing%20shapes%2C%20minimal%20modern%20design%2C%20gentle%20light%20rays%2C%20airy%20atmosphere%2C%20no%20text%2C%20clean%20elegant%20composition%2C%20subtle%20texture&width=1800&height=800&seq=cta-bg-home&orientation=landscape`,
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-primary-600/70 to-primary-800/80"></div>

          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
              每天都有新精彩，快来加入我们吧！
            </h2>
            <p className="text-background-100/85 text-sm md:text-base mb-8 leading-relaxed">
              每天更新精选视频，搞笑、甜蜜、治愈、感动——你想要的全都有。点击下方按钮，马上开始你的欢乐时光！
            </p>
            <Link
              to="/category/quwei-gaoxiao"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 hover:bg-background-100 text-primary-600 rounded-full text-base font-bold transition-all duration-200 whitespace-nowrap cursor-pointer shadow-xl"
            >
              <i className="ri-play-circle-fill text-xl"></i>
              免费观看
            </Link>
          </div>
        </section>

        {/* All Videos Quick Browse */}
        <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">
                更多精彩视频
              </h2>
              <p className="text-foreground-500 text-sm">随便逛逛，发现更多有趣内容</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
              {videos.map((video) => (
                <Link
                  key={video.id}
                  to={`/article/${video.id}`}
                  className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.03] cursor-pointer"
                >
                  <div className="relative aspect-video overflow-hidden">
                    <img
                      src={video.coverImage}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      title={`羞羞视频 - ${video.title}`}
                    />
                    <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-foreground-900/75 backdrop-blur-sm rounded text-background-50 text-xs font-mono">
                      {video.duration}
                    </div>
                  </div>
                  <div className="p-3">
                    <h3 className="font-medium text-foreground-900 text-xs md:text-sm line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                      {video.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-2 text-xs text-foreground-400">
                      <span>{video.category}</span>
                      <span>·</span>
                      <span>{video.viewCount >= 10000 ? `${(video.viewCount / 10000).toFixed(1)}万次` : `${video.viewCount}次`}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}